
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M3.343 19.273L2 17.537l1.845-1.752c1.4-1.33 3.44-1.454 4.963-.304l.099.075a1.87 1.87 0 002.317-.028l.038-.03c1.479-1.17 3.438-1.13 4.875.101.767.656 1.85.617 2.577-.093l1.04-1.016 1.365 1.715-1.04 1.015c-1.467 1.435-3.655 1.513-5.203.188-.712-.61-1.683-.63-2.414-.05l-.039.03c-1.389 1.099-3.269 1.122-4.679.057l-.098-.075c-.755-.57-1.765-.507-2.458.15l-1.845 1.753zM23.19 9l6.747 7.474-6.75 7.433-1.454-1.622 5.28-5.815-5.283-5.853L23.19 9z"}})])
      }
    
      }
    